import { environment } from '../environments/environment';

export const roiDefaultStyle = {
    color: '#BBBBBB',
    fillOpacity: 0,
    pane: 'roiPane',
};
export const roiOverStyle = { color: environment.colorRoi, fillOpacity: 0 };
